if($('.type-detail').length){
    if($('#productsAlternative').length){
             var variantDefaultName = $('.p-detail-inner-header h1').text().trim()
             var variantDefaultCode = $('.p-detail-inner-header span.p-code>span:not(.p-code-label)').text().trim()
             let partsDefault = variantDefaultCode.split('-');  // Rozdělí text na části podle '-'
           

             
                $('#productsAlternative .products-block').append('<div class="product"><span class="no-display" data-micro="sku">col-'+partsDefault[partsDefault.length - 1]+'</span><a href="'+document.location.pathname+'" class="name">'+variantDefaultName+'</a><div><a href="'+document.location.pathname+'" class="image"><img src="'+$('.p-image a').attr('href')+'" data-micro-image="'+$('.p-image a').attr('href')+'"></a></div></div>')
                var products = $('#productsAlternative .product');
                products.sort(function(a, b) {
                    var textA = $(a).find('.name').text().trim();
                    var textB = $(b).find('.name').text().trim();
                    return textA.localeCompare(textB, 'cs');
                });
                  var custom_var = '<div class="pseudoVariant" id="variant">'
                  custom_var += '<div class="h3">Varianta:</div>'
                  custom_var += '<div class="related-var">'
                  $.each(products, function(index, element) {
                    let sku = $(element).find('span[data-micro="sku"]').text().trim();
                    let parts = sku.split('-');  // Rozdělí text na části podle '-'
                 
                   
                    var text = $(element).find('.name').text().trim()
                    var url = $(element).find('.image').attr('href')
                    custom_var += '<div class="inner show-tooltip'
                    if(url === document.location.pathname){
                      custom_var += ' active'
                    }
                    custom_var += '" title="'+text+'" data-title="'+text+'">'
              //      if($('body.desktop').length){
                        custom_var += '<a href="'+$(element).find('.image').attr('href')+'">'
                  //  }
                 //   if($('body.mobile').length){
                 //       custom_var += '<a href="'+$(element).find('.image').attr('href')+'#variant">'
                 //   }
                   
                //    console.log($(element).attr('data-multicolor'))

                    console.log($(element).find('.image').html())
                        custom_var += '<span class="customProductColor"><img src="'+$(element).find('.image img').attr('data-micro-image').trim()+'"></span></a>'
                        custom_var += '<span class="customCode">col-'+parts[parts.length - 1]+'</span>'
                    
                    
                    custom_var += '</div>'
                  })
                  custom_var += '</div>'
                  custom_var += '</div>'
                  $('.p-info-wrapper').append(custom_var);
                  initTooltips();
           
            
        
        
    }



    if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
        $('.p-image-wrapper .p-image').append('<div class="thumbCount"><span class="from"></span> z <span class="to">'+$('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image').length+'</span></div>')
        $('.p-image-wrapper').addClass('haveThumbnails')
        $('.p-image-wrapper').append('<span class="arrow-prev"></span><span class="arrow-next"></span>');
    
        $('body').on('click', '.arrow-prev, .arrow-next', function () {
            var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
            var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
            var isNext = $(this).hasClass('arrow-next');
            var totalThumbnails = thumbnails.length;
            var currentIndex = thumbnails.index(highlightedThumbnail);
    
            // Odebrání třídy 'highlighted' u všech thumbnailů
            thumbnails.removeClass('highlighted');
    
            // Logika pro určení nového zvýrazněného thumbnailu
            if (highlightedThumbnail.length === 0) {
                highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
            } else {
                currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
                highlightedThumbnail = thumbnails.eq(currentIndex);
            }
    
            // Přidání třídy 'highlighted' k nově zvýrazněnému thumbnailu
            highlightedThumbnail.addClass('highlighted');
    
            // Kontrola pro .show360image a skrytí/zobrazení .image360 a .p-image
            toggle360ImageVisibility(highlightedThumbnail);
    
            // Aktualizace hlavního obrázku
            setTimeout(function () {
                updateMainImage(highlightedThumbnail);
                updateThumbnailCount(thumbnails);
            }, 10);
        });
    
        function updateMainImage(highlightedThumbnail) {
            var findHighlighted = highlightedThumbnail.attr('href');
            var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
            $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
        }
    
        function updateThumbnailCount(thumbnails) {
            var highlightedIndex = thumbnails.index($('.p-thumbnails-inner a.highlighted')) + 1;
            var totalThumbnails = thumbnails.length;
            $('.thumbCount .from').html(highlightedIndex);
            $('.thumbCount .to').html(totalThumbnails);
        }
    
        function toggle360ImageVisibility(highlightedThumbnail) {
            var is360Image = highlightedThumbnail.hasClass('show360image');
    
            if (is360Image) {
                // Pokud ano, zobrazit .image360 a skrýt .p-image
                $('.image360').show();
                $('.p-image').hide();
            } else {
                // Pokud ne, skrýt .image360 a zobrazit .p-image
                $('.image360').hide();
                $('.p-image').show();
            }
        }
    
        // Inicializace počtu thumbnailů
        updateThumbnailCount($('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image'));
    }
    $('.p-info-wrapper').append('<div class="customIcon"></div>')
   // 
    $('.extended-description .detail-parameters tr th').each(function(){
        var customText = $(this).closest('tr').find('td').text().trim();
        var customImage = '/user/documents/upload/ikony/'+customText.normalize('NFD').replace(/[^\w]/g, '').toLowerCase()+'-ico.svg?' + new Date().getMinutes();
        if($(this).text().match('Materiál') || $(this).text().match('počet lůžek') || $(this).text().match('zapínání')){
            var imgElement = $('<img>', {
                src: customImage,
                alt: customText,
                error: function() {
                    $(this).closest('span').remove();
                }
            });
            var spanElement = $('<span>', {
                class: 'show-tooltip',
                'data-title': customText,
                'data-original-title': customText
            }).append(imgElement);
            $('.customIcon').append(spanElement);
        }
    });
    
    $('.basic-description table').wrap('<div class="overflow-table"></div>')
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone())
    $('.p-info-wrapper').append('<div class="kosik"></div>')
    if($('.extended-description .detail-parameters th:contains("první použití")').length){
        $('.extended-description .detail-parameters th:contains("první použití")').closest('tr').hide()
        $('.p-info-wrapper').append('<div class="FirstUse"><p>'+$('.extended-description .detail-parameters th:contains("první použití")').closest('tr').find('td').text()+'</p></div>')
    }
    $('.kosik').append($('.p-final-price-wrapper'))
    $('.kosik').append($('.add-to-cart'))
    if($('.variant-list').length>0){
        $('.variant-list select').each(function(){
            var optionLength = $(this).find('option').length
            var data_parameter_id = $(this).data('parameter-id')
            if($('.variant-list #simple-variants').length){
                var html_var = '<div class="custom-variant"><div class="h3">Varianta</div>'
            }
            else{
                var html_var = '<div class="custom-variant"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
            }
           
            html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
            if($('.variant-list #simple-variants').length){
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    if ($.isNumeric($(this).val())) {
                        var getOption = $(this).text()
                        html_var += '<div class="variant" data-value="'+data_value+'" data-index="'+ $(this).data('index')+'" data-min="'+ $(this).data('data-min')+'" data-max="'+ $(this).data('data-max')+'">'
                        html_var += '<div class="text">'+getOption.split(':')[1].split('-')[0].trim()+'</div>'
                        html_var += '</div>'
                    }
                })
            }
            else{
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    if ($.isNumeric($(this).val())) {
                        html_var += '<div class="variant show-tooltip" title="'+$(this).text()+'" data-original-title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                        html_var += '<div class="text">'+$(this).text()+'</div>'
                        html_var += '</div>'
                    }
                })
            }

            
            html_var += '</div></div>'
            $(this).after(html_var)
            $(this).closest('.variant-list select').hide()
           $(this).closest('.variant-list span').hide()
          
        })

        var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
        for (var parentKey in necessaryVariantData) {
            if (necessaryVariantData.hasOwnProperty(parentKey)) {
                var variant = necessaryVariantData[parentKey];
                console.log(variant)
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-')).addClass('haveVariantImage').append('<div class="image"><img src="'+variant.variantImage.detail_small+'" alt="'+variant.name+'"></div><dív class="bottomText">col. '+variant.code.split('-')[1]+'</div>')
                initTooltips();
            }
        }
        
    }
    $(document).on('click', '.custom-variant-wrap .variant', function(){
        if($('.variant-list #simple-variants').length){

            variantData = $(this).data('index')
            $("select#simple-variants-select option").filter(function (){return $(this).attr('data-index') == variantData }).change().prop("selected", true)
            var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
            var $splitParameters = $(selector);
            $splitParameters.trigger('change');
            $(this).closest('.custom-variant-wrap').find(".variant:not([data-index='"+variantData+"'])").removeClass("active");
            $(this).addClass("active");    
            $("select#simple-variants-select")[0].dispatchEvent(new Event('change'));
        }
        else{
            const variantData = $(this).data('value')
            const variantParameterId = $(this).data('parameter-id')
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
            var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
            var $splitParameters = $(selector);
            $splitParameters.trigger('change');
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active");    
            $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
            $('.custom-variant-wrap .variant').each(function(){
                const variantData = $(this).data('value')
                const variantParameterId = $(this).data('parameter-id')
                const unavailable = $("select[data-parameter-id='"+variantParameterId+"']  option[value='" + variantData + "']").hasClass("unavailable-option")    
                if (unavailable === true) {
                    $(this).addClass("unavailable").removeClass("active")
                }
                else{
                    $(this).removeClass("unavailable")
                } 
            })
        }
        
        
       
    })

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
              $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
        if($('#simple-variants .advanced-parameter').length>1){
            $('#simple-variants .advanced-parameter').first().trigger('click')
        }
    })
}